import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { IncidentType } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
import { AddIncidenttypeDialogComponent } from './add-incidenttype-dialog/add-incidenttype-dialog.component';
import { EditIncidentTtypeDialogComponent } from './edit-incident-ttype-dialog/edit-incident-ttype-dialog.component';

@Component({
  selector: 'app-config-setup-incident',
  templateUrl: './config-setup-incident.component.html',
  styleUrls: ['./config-setup-incident.component.css']
})
export class ConfigSetupIncidentComponent implements OnInit {

  constructor(public dialog: MatDialog,   
    private _safetyConfigService:SafetyConfigService,) { }

  ngOnInit() {
  
    this.GetIncidentTypes();
  }
  incidentList:IncidentType[]=[];
  
  OpenAddIncidentTypeDialog(){
    const dialogRef = this.dialog.open(AddIncidenttypeDialogComponent, { 
      disableClose: true,
      data:{
       // catId:CatInf.ID
      }
  
      });
  
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
      this.GetIncidentTypes();
     
  
      console.log('The dialog was closed');
     
     }
   });
   
  }
  GetIncidentTypes(){
    this._safetyConfigService.Get().subscribe(res=>{ 
    
    this.incidentList=res;
   
    console.log( "incidents",this.incidentList)
   
    })
  }

  OpenEditIncidentTypeDialog(CatInf:IncidentType){
    const dialogRef = this.dialog.open(EditIncidentTtypeDialogComponent, { 
      disableClose: true,
      data:{
        IncId:CatInf.ID,
        trifr:CatInf.TRIFR,
        active:CatInf.Active
      }
  
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result==true){ 
         
        }else if(result==false){
         this.GetIncidentTypes();
     
         console.log('The dialog was closed');
        }
      });
     }

  ChangeActive(cat)
  {
       
    let params = new  IncidentType();
    params.ID = cat.ID;
    params.Name = cat.Name;
    params.Description = cat.Description
    params.Active=!cat.Active;
    params.TRIFR=cat.TRIFR;
  
    //create new category
    this._safetyConfigService.UpdateIncidentType(params).subscribe(res => {
     
      if (res.m_Item1) {
        this.GetIncidentTypes()
      }
      // this.dialogRef.close();

    })


     }

     ChangeTRIFR(cat){
      let params = new  IncidentType();
      params.ID = cat.ID;
      params.TRIFR=!cat.TRIFR;
    
      //create new category
      this._safetyConfigService.ToggleTRIFR(params).subscribe(res => {
       
        if (res.m_Item1) {
          this.GetIncidentTypes()
        }
        // this.dialogRef.close();
       
     
      });
    }
}
